import { ReactNode, useContext } from 'react';
import Typography from '@mui/material/Typography';
import Box from '@mui/material/Box';
import { TimelineContext } from '@/common/components/timeline/TimelineContext.ts';

export interface TimelineLineBadgeProps {
  children?: ReactNode;
}

export const TimelineLineBadge = ({ children }: TimelineLineBadgeProps) => {
  const { lineColor } = useContext(TimelineContext);

  return (
    <Box
      border={1}
      borderColor={lineColor}
      lineHeight={1}
      py={0.2}
      px={0.5}
      borderRadius={0.5}
      textAlign="center"
    >
      <Typography variant="caption" color="textSecondary" lineHeight={1}>
        {children}
      </Typography>
    </Box>
  );
};
